import React, { useState, useEffect } from 'react';
import { Column } from '@ant-design/plots';

const ColumnPlot = (props) => {
  const data = Object.keys(props.data).map((xField) => ({
    xField: xField
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),
    yField: parseFloat(props.data[xField].toFixed(2)),
  }));

  const config = {
    data,
    padding: 'auto',
    xField: 'xField',
    yField: 'yField',
    color: 'white',
    tooltip: {
      items: [
        { field: 'xField', alias: props.xFieldLabel },
        { field: 'yField', alias: props.yFieldLabel },
      ],
    },
    meta: {
      xField: {
        alias: 'Nutrient',
      },
      yField: {
        alias: 'Valor',
      },
    },
    xAxis: {
      label: {
        style: {
          fill: 'white',
        },
      },
    },
    yAxis: {
      label: {
        style: {
          fill: 'white',
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '20em', margin: 'auto' }}>
      <Column {...config} />
    </div>
  );
};

export default ColumnPlot;
